/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EpaSepStatsBarResponse
 */
export interface EpaSepStatsBarResponse {
    /**
     * 
     * @type {number}
     * @memberof EpaSepStatsBarResponse
     */
    companyCount: number;
    /**
     * 
     * @type {number}
     * @memberof EpaSepStatsBarResponse
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof EpaSepStatsBarResponse
     */
    avgRate: number;
    /**
     * 
     * @type {number}
     * @memberof EpaSepStatsBarResponse
     */
    highestRate: number;
    /**
     * 
     * @type {number}
     * @memberof EpaSepStatsBarResponse
     */
    avgResponseTimeDays: number;
    /**
     * 
     * @type {number}
     * @memberof EpaSepStatsBarResponse
     */
    avgCompletionTimeDays: number;
}

/**
 * Check if a given object implements the EpaSepStatsBarResponse interface.
 */
export function instanceOfEpaSepStatsBarResponse(value: object): value is EpaSepStatsBarResponse {
    if ((!('companyCount' in (value as Record<string, any>)) && !('company_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['companyCount'] === undefined && (value as Record<string, any>)['company_count'] === undefined)) return false;
    if ((!('totalCount' in (value as Record<string, any>)) && !('total_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['totalCount'] === undefined && (value as Record<string, any>)['total_count'] === undefined)) return false;
    if ((!('avgRate' in (value as Record<string, any>)) && !('avg_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['avgRate'] === undefined && (value as Record<string, any>)['avg_rate'] === undefined)) return false;
    if ((!('highestRate' in (value as Record<string, any>)) && !('highest_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['highestRate'] === undefined && (value as Record<string, any>)['highest_rate'] === undefined)) return false;
    if ((!('avgResponseTimeDays' in (value as Record<string, any>)) && !('avg_response_time_days' in (value as Record<string, any>))) || ((value as Record<string, any>)['avgResponseTimeDays'] === undefined && (value as Record<string, any>)['avg_response_time_days'] === undefined)) return false;
    if ((!('avgCompletionTimeDays' in (value as Record<string, any>)) && !('avg_completion_time_days' in (value as Record<string, any>))) || ((value as Record<string, any>)['avgCompletionTimeDays'] === undefined && (value as Record<string, any>)['avg_completion_time_days'] === undefined)) return false;
    return true;
}

export function EpaSepStatsBarResponseFromJSON(json: any): EpaSepStatsBarResponse {
    return EpaSepStatsBarResponseFromJSONTyped(json, false);
}

export function EpaSepStatsBarResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaSepStatsBarResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCount': json['company_count'],
        'totalCount': json['total_count'],
        'avgRate': json['avg_rate'],
        'highestRate': json['highest_rate'],
        'avgResponseTimeDays': json['avg_response_time_days'],
        'avgCompletionTimeDays': json['avg_completion_time_days'],
    };
}

export function EpaSepStatsBarResponseToJSON(json: any): EpaSepStatsBarResponse {
    return EpaSepStatsBarResponseToJSONTyped(json, false);
}

export function EpaSepStatsBarResponseToJSONTyped(value?: EpaSepStatsBarResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_count': value['companyCount'],
        'total_count': value['totalCount'],
        'avg_rate': value['avgRate'],
        'highest_rate': value['highestRate'],
        'avg_response_time_days': value['avgResponseTimeDays'],
        'avg_completion_time_days': value['avgCompletionTimeDays'],
    };
}

